// extracted by mini-css-extract-plugin
export default {"root":"style_root__lvqMA","tips":"style_tips__1wTyR"};